interface CardLogoProps {
  src: string;
  alt?: string;
}

const CardLogo = ({ src, alt }: CardLogoProps) => {
  return <img src={src} alt={alt} style={{ height: "14px" }} />;
};

export default CardLogo;
